/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ChecklistId200,
  GetApiV1ChecklistId401,
  GetApiV1ChecklistId404,
  GetApiV1ChecklistId500,
  GetApiV1ChecklistIdPathParams,
  GetApiV1ChecklistIdQueryResponse,
} from "../../types/checkListRegistroController/GetApiV1ChecklistId.ts";
import { checkListViewModelSchema } from "../checkListViewModelSchema.ts";

export const getApiV1ChecklistIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ChecklistIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ChecklistId200Schema = z.lazy(
  () => checkListViewModelSchema,
) as unknown as ToZod<GetApiV1ChecklistId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ChecklistId401Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ChecklistId404Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ChecklistId500Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistId500>;

export const getApiV1ChecklistIdQueryResponseSchema = z.lazy(
  () => getApiV1ChecklistId200Schema,
) as unknown as ToZod<GetApiV1ChecklistIdQueryResponse>;
